/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".flying-club__content[_ngcontent-%COMP%]{font-size:.789em;color:#626767;line-height:1.36;white-space:pre-wrap}.data-block__label__override[_ngcontent-%COMP%]{text-align:right}"];
export { styles as styles };
